module.exports = __webpack_public_path__ + "imgs/pin.d0e480c81d4583eb93037beac654f5bc.svg";